var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"iv2-customize__logo position-fixed"},[_c('img',{attrs:{"src":_vm.image_src,"alt":_vm.alt_text}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }